var track = require('@enhancer/fe-error-track');
track('enhancer-forum-assets');
window.enhancerMaxFileSize = 1024 * 1024;


;(function () {
	var ua = navigator.userAgent;
	if (ua.match(/(Android)\s+([\d.]+)/) || ua.match(/(iPhone\sOS)\s([\d_]+)/)) {
		$('body').addClass('mobile');
	}

	var cookie = document.cookie || '';
	$('body').addClass(cookie.match(/uid=\d+/) ? 'login' : 'nologin');
})();




// WEBPACK FOOTER //
// ./src/app/app.js